import {PAGES} from "../../../../../core/consts";
import {CompetitorIndexPageRouteMetaDataModel} from "./competitor.index-page.route.meta-data.model";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorIndexPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.index,
      componentImport: () => import("../components/competitor.index-page" /* webpackChunkName: "competitor-index-page" */ ),
      metadataType: CompetitorIndexPageRouteMetaDataModel
    });

    this.index = true;
  }
}
